import makeApiCall, { makeUnauthenticatedApiCall } from "../master/axiosIndex";

const tenderApis = {
  // List Tenders - GET /tms/tender/list
  fetchTenderList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/tms/tender/list",
      params,
    }),

  // View Tender - GET /tms/tender/:id
  fetchTenderById: (tenderId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/tms/tender/${tenderId}`,
    }),

  // Express Interest - POST /tms/tender/express-interest/:id
  // Handles both "Interested" and "Not Interested"
  expressInterest: (
    tenderId: number,
    data: {
      interestStatus: "Interested" | "Not Interested";
      supplierId?: number;
      contractorId?: number;
      remarks?: string;
    }
  ): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/tms/tender/express-interest/${tenderId}`,
      data: { ...data, tenderId },
    }),

  // Submit Bid - POST /tms/tender/submit-bid/:id
  // multipart/form-data: bid (JSON string) + files
  submitBid: (tenderId: number, data: FormData): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/tms/tender/submit-bid/${tenderId}`,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // Update Bid - PUT /tms/tender/update-bid/:supplierBidId
  // multipart/form-data: bid (JSON string) + files
  updateBid: (supplierBidId: number, data: FormData): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/tms/tender/update-bid/${supplierBidId}`,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // Fetch Bid Responses - GET /tms/tender/bid-responses/:id
  fetchBidResponses: (tenderId: number, params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/tms/tender/bid-responses/${tenderId}`,
      params,
    }),

  // Get Tender With Bid - GET /tms/tender/tender-with-bid/:tenderId/:bidId
  getTenderWithBid: (
    tenderId: number,
    bidId: number,
    bidType?: "Supplier" | "Contractor"
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/tms/tender/tender-with-bid/${tenderId}/${bidId}`,
      params: bidType ? { bidType } : undefined,
    }),
  // Check Supplier Bid Status - GET /tms/tender/check-supplier-bid-status/:tenderId/:supplierId
  checkSupplierBidStatus: (
    tenderId: number,
    supplierId: number
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/tms/tender/check-supplier-bid-status/${tenderId}/${supplierId}`,
    }),

  // Validate Bid Bulk Upload - POST /tms/tender-bulk-upload/validate-bid
  validateBidBulkUpload: (data: FormData): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/tms/tender-bulk-upload/validate-bid",
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // Validate Discount Bulk Upload - POST /tms/tender-bulk-upload/validate-discount
  validateDiscountBulkUpload: (data: FormData): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/tms/tender-bulk-upload/validate-discount",
      data,
    }),

  // Apply Discount - PUT /tms/tender/apply-discount/:tenderId/:supplierBidId
  applyDiscount: (
    tenderId: number,
    supplierBidId: number,
    data: {
      materialDiscounts: { bidMaterialId: number; discountPercent: number }[];
      revisionReason: string;
    }
  ): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/tms/tender/apply-discount/${tenderId}/${supplierBidId}`,
      data,
    }),

  // ===== Public Link APIs (Unauthenticated) =====

  // Verify public link - POST /tms/tender/verify-public-link
  verifyPublicLink: (linkId: string): Promise<any> =>
    makeUnauthenticatedApiCall<any>({
      method: "post",
      url: "/tms/tender/verify-public-link",
      data: { linkId },
    }),

  // Send OTP - POST /auth/validateUserAndSendOtp
  sendOtp: (
    mobileNumber: string,
    email: string,
    orgType: string = "Seller"
  ): Promise<any> =>
    makeUnauthenticatedApiCall<any>({
      method: "post",
      url: "/auth/validateUserAndSendOtp",
      data: { mobileNumber, email, orgType },
    }),

  // Verify OTP - POST /auth/verifyPublicLinkOtp
  verifyOtp: (mobileNumber: string, otp: string): Promise<any> =>
    makeUnauthenticatedApiCall<any>({
      method: "post",
      url: "/auth/verifyPublicLinkOtp",
      data: { mobileNumber, otp },
    }),

  // Create public supplier - POST /buyer/createPublicSupplier
  createPublicSupplier: (data: any): Promise<any> =>
    makeUnauthenticatedApiCall<any>({
      method: "post",
      url: "/buyer/createPublicSupplier",
      data,
    }),
};

export default tenderApis;
